import { useRef } from 'react';
import { isEqual } from 'lodash-es';
const NOTHING_TO_HAND_BACK = {
    search: null,
    selectedIds: null
};
const sameSelection = (one, other)=>isEqual([
        ...one
    ].sort(), [
        ...other
    ].sort());
export const useConversationBoardScope = (narrowingOf)=>{
    // WHY a ref: the seller's scope is frozen at the moment the conversation overwrote it — it outlives renders without driving any (ANCR-5802).
    const remembered = useRef(null);
    // WHY sealed, not just forgotten: the turn the seller asked for stamps the board AFTER their prompt, and re-arming there would hand back a scope they replaced on purpose (ANCR-5802).
    const sealed = useRef(false);
    const narrowsTheSame = (one, other)=>isEqual(narrowingOf(one), narrowingOf(other));
    return {
        rememberStamp: (board, stamped)=>{
            if (sealed.current) return;
            const held = remembered.current;
            const searchIsStillTheConversations = held != null && narrowsTheSame(held.stamped.search, board.search);
            const selectionIsStillTheConversations = held != null && sameSelection(held.stamped.selectedIds, board.selectedIds);
            remembered.current = {
                sellerScope: {
                    search: held != null && searchIsStillTheConversations ? held.sellerScope.search : board.search,
                    selectedIds: held != null && selectionIsStillTheConversations ? held.sellerScope.selectedIds : board.selectedIds
                },
                stamped
            };
        },
        handBack: (current)=>{
            const held = remembered.current;
            remembered.current = null;
            sealed.current = false;
            if (held == null) return NOTHING_TO_HAND_BACK;
            const searchIsStillTheConversations = narrowsTheSame(held.stamped.search, current.search);
            const sellerSearchDiffers = !narrowsTheSame(held.sellerScope.search, current.search);
            const selectionIsStillTheConversations = sameSelection(held.stamped.selectedIds, current.selectedIds);
            const sellerSelectionDiffers = !sameSelection(held.sellerScope.selectedIds, current.selectedIds);
            return {
                search: searchIsStillTheConversations && sellerSearchDiffers ? held.sellerScope.search : null,
                selectedIds: selectionIsStillTheConversations && sellerSelectionDiffers ? held.sellerScope.selectedIds : null
            };
        },
        forget: ()=>{
            remembered.current = null;
            sealed.current = true;
        }
    };
};
